/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CreateRepositoryGitProviderDataParser = 
/* #__PURE__ */ parsers.object([
    ['name', codecString],
    ['assignmentId', codecNumber, 'assignment_id'],
]);
export class CreateRepositoryGitProviderData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateRepositoryGitProviderDataParser.decode(input).map(res => new CreateRepositoryGitProviderData(res));
    }
    static unsafeDecode(input) {
        return CreateRepositoryGitProviderData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateRepositoryGitProviderDataParser.encode(data);
    }
    static schema() {
        return CreateRepositoryGitProviderDataParser.schema();
    }
}
